import { render, staticRenderFns } from "./StudentPaymentMethods.vue?vue&type=template&id=670f9b52&"
import script from "./StudentPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./StudentPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports